// Must match the "Sold out customizations" tab's id in Menu/Constant.js
export const CUSTOMIZATION_SOLD_OUT_TAB_ID = 6;
export const FETCH_LIMIT = 100;
export const SEARCH_DEBOUNCE_MS = 600;

export const QUERY_KEYS = {
  SOLD_OUT_CUSTOMIZATIONS: 'sold-out-customizations',
} as const;
